import * as React from 'react'
const SvgIcoGalec = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    xmlSpace='preserve'
    viewBox='0 0 200 200'
    preserveAspectRatio="none"
    {...props}
  >
    <style>
      {
        '.ICO_GALEC_N_svg__st0{display:none}.ICO_GALEC_N_svg__st1{display:inline}.ICO_GALEC_N_svg__st2{fill:#7984ba}.ICO_GALEC_N_svg__st3,.ICO_GALEC_N_svg__st4{fill-rule:evenodd;clip-rule:evenodd}.ICO_GALEC_N_svg__st4{fill:#7984ba}'
      }
    </style>
    <g id='ICO_GALEC_N_svg__Calque_9'>
      <path d='M88.64 88.89c0-8.39 6.63-15.28 15.15-15.28 4.67 0 8.73 1.97 11.3 5.05l-4.96 4.15c-1.58-1.84-3.81-2.95-6.33-2.95-4.75 0-8.39 4.11-8.39 9.03 0 4.84 3.55 9.25 8.6 9.25 3.29 0 6.93-1.84 6.93-4.75h-8.3v-5.44h15.62c0 11.17-6.21 16.18-14.08 16.18-9.07-.01-15.54-6.94-15.54-15.24' />
      <circle
        cx={103.04}
        cy={89.23}
        r={28.77}
        style={{
          fill: 'none',
          stroke: '#000',
          strokeMiterlimit: 10,
        }}
      />
    </g>
  </svg>
)
export default SvgIcoGalec

